import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const StyledModal = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 10
});

export const ButtonsContainer = styled("div")({
  marginBottom: -10,
  padding: 10,
  paddingBottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  "& button": {
    width: 150,
    height: 20,
    minHeight: 40,
    "& span": {
      textAlign: "center",
      justifyContent: "center"
    }
  }
});

export const ModalPaper = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
  borderRadius: 15,
  padding: "32px",
  textAlign: "center",
  maxHeight: "calc(100vh - 60px)",
  overflow: "auto",
  margin: "30px 0",
  position: "relative"
}));

export const SearchContainer = styled("div")({
  zIndex: 10,
  margin: 10,
  display: "flex",
  "& label": {
    color: "#000",
    zIndex: 999,
    marginLeft: 5,
    marginTop: 5
  },
  "& input": {
    backgroundColor: "#eee",
    padding: "12px !important",
    borderRadius: 3,
    opacity: 0.8
  },
  "& .MuiAutocomplete-endAdornment": {
    "& button": {
      color: "#000"
    }
  }
});

export const MapContainer = styled("div")({
  width: "auto",
  height: "60vh",
  marginRight: "-25px"
});

export const RootContainer = styled("div")({
  width: "30vw",
  "& .MuiFormLabel-root .MuiInputLabel-root .MuiInputLabel-formControl .MuiInputLabel-animated": {
    color: "#000"
  }
});

export const MapDiv = styled("div")({
  alignItems: "center",
  justifyContent: "center",
  paddingRight: 25
});

export const Container = styled("div")({
  margin: 20
});

export const ListBox = styled("div")({
  backgroundColor: "#eee",
  width: "88%",
  opacity: 0.8
});
